import { connect } from 'react-redux';
import { compose } from 'recompose';

import OperatorTable from './OperatorTable';
import {
  openOperatorEditModal,
  openOperatorMergeModal,
  closeOperatorMergeModal,
  closeOperatorEditModal,
} from '../actions';

import {
  getOperatorEditModal,
  getOperatorMergeModal,
  getSelectedOperator,
} from '../selectors';

import { enableLookupFeature } from '../../../configuration/selectors';

import { queryOperatorGQL } from '../graphql';

const mapStateToProps = (state) => {
  return {
    selectedOperator: getSelectedOperator(state),
    showOperatorEntryModal: getOperatorEditModal(state),
    showOperatorMergeModal: getOperatorMergeModal(state),
    enableLookupFeature: enableLookupFeature(state),
  };
};

const mapDispatchToProps = {
  openOperatorEditModal,
  openOperatorMergeModal,
  closeOperatorMergeModal,
  closeOperatorEditModal,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  queryOperatorGQL,
  withRedux,
);

export default enhance(OperatorTable);
